import styled from 'styled-components';
import { ReactElement } from 'react';

import { DocplannerPractitioner } from '@dreryk/egabinet-docplanner-frontend-api';
import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import { createTranslatedText } from '@dreryk/react-common';
import { Select } from '@dreryk/react-components';

import { doctorsMappingsTranslationKeys } from '../../translations';

import { AddDoctorAssociationFormController } from './AddDoctorAssociation/addDoctorAssociation.types';

type PractitionersSelectProps = {
   readonly practitioners: PractitionerView[];
   readonly register: AddDoctorAssociationFormController['register'];
   readonly defaultValue: DocplannerPractitioner | undefined;
};

const getPractitionerDisplayValue = (practitioner?: DocplannerPractitioner | PractitionerView): string =>
   practitioner ? `${practitioner.lastName.asString()} ${practitioner.firstName.asString()}` : '';

const StyledSelect = styled(Select)`
   width: 400px;
` as typeof Select;

const mapPractitionerViewToDocplannerPractitioner = (practitionerView: PractitionerView): DocplannerPractitioner => ({
   id: practitionerView.id,
   firstName: practitionerView.firstName,
   lastName: practitionerView.lastName,
});

export const PractitionersSelect = (props: PractitionersSelectProps): ReactElement => {
   return (
      <StyledSelect<DocplannerPractitioner>
         testId={'practitioners'}
         triggerLabelExtractor={getPractitionerDisplayValue}
         controller={props.register('eGabinetPractitioner')}
         defaultValue={props.defaultValue}
         placeholder={doctorsMappingsTranslationKeys.chooseOrLeaveEmpty}
         showClearIcon
      >
         <Select.List items={props.practitioners} keyExtractor={'id'}>
            {(practitioner) => (
               <Select.Item<DocplannerPractitioner>
                  item={mapPractitionerViewToDocplannerPractitioner(practitioner)}
                  testId={practitioner.id}
                  label={createTranslatedText(getPractitionerDisplayValue(practitioner))}
               />
            )}
         </Select.List>
      </StyledSelect>
   );
};
